import { render, staticRenderFns } from "./ElectricityInvoiceDetail.vue?vue&type=template&id=741d6770&"
import script from "./ElectricityInvoiceDetail.vue?vue&type=script&lang=ts&"
export * from "./ElectricityInvoiceDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports